import { Injectable, Signal, computed, inject } from '@angular/core';
import { mergeMap, Observable, of } from 'rxjs';
import { OutcomesService } from './outcomes.service';
import { Outcomes } from '../models';
import { Document } from '@documents/models/document-type';

@Injectable({
  providedIn: 'root',
})
export class OutcomesFacadeService {
  private readonly _outcomeService = inject(OutcomesService);
  outcomeTotal$: Observable<number> = this._outcomeService.outcomesTotal$.pipe(
    mergeMap((outcomesTotal) => {
      return of(outcomesTotal);
    }),
  );

  outcomes$: Observable<Outcomes[]> = this._outcomeService.outcomes$.pipe(
    mergeMap((outcomes) => {
      return of(outcomes);
    }),
  );

  $outcomeTotal: Signal<number> = computed(() =>
    this._outcomeService.$outcomesTotal(),
  );
  $outcomes: Signal<Outcomes[]> = computed(() =>
    this._outcomeService.$outcomes(),
  );
  $outcomeDocuments: Signal<Document[]> = computed(() =>
    this._outcomeService.$outcomeDocuments(),
  );
}
